module.exports = __webpack_public_path__ + "static/media/FRA.c0c8c3af.jpg";